<template>
  <div class="editor">
    <el-button
      style="margin-bottom: 10px;"
      @click="handleOpenPictureZone">从素材空间上传</el-button>
    <Editor
      :id="`${key}${isShelves ? '-she' : ''}`"
      :ref="key"
      :value="value"
      :menus="menus"
      :placeholder="placeholder"
      :extraAttr="extraAttr"
      @change="onChange"
      @blur="blurHandle"
      @fullScreenChange="editorFullScreenChange" />
    <ChoosePictrueZone v-show="choosePictrueZoneVisible" ref="choosePictrueZoneRef"/>
    <ChooseNewPictrueZone v-show="chooseNewPictrueZoneVisible" :appendToBody="true" ref="chooseNewPictrueZoneRef"/>
  </div>
</template>

<script>
import {editor_mixin} from '@/components/Editor/index.js'
import ChoosePictrueZone from "@/components/Uploads/ChoosePictrueZone.vue";
import ChooseNewPictrueZone from "@/components/Uploads/ChooseNewPictrueZone.vue";
export default {
  components: {
    ChoosePictrueZone,
    ChooseNewPictrueZone
  },
  mixins: [editor_mixin],
  inject: {
    isShelves: { default: false },
    elFormItem: { default: null },
    injectedOuterId: { default: () => '', from: 'outerId' },
  },
  props: ["props", "value"],
  data(){
    return {
      choosePictrueZoneVisible: false,
      chooseNewPictrueZoneVisible: false
    }
  },
  computed: {
    key() {
      return this.props.name
    },
    menus() {
      // 手机端只允许上传图片
      return []
    },
    placeholder() {
      return this.props?.placeholder || '请输入'
    },
    extraAttr() {
      return this.props?.extraAttr || {}
    },
    // 与其它组件保持一致：根据公司注册时间切换新旧素材空间
    useNewPictureZone() {
      let companyCreated = 0;
      try {
        const raw = window.localStorage.getItem('userinfo');
        if (raw) {
          const u = JSON.parse(raw);
          companyCreated = Number(u && u.companyCreated) || 0;
        }
      } catch (e) {}
      const START_TS = new Date(2026, 2, 1, 0, 0, 0).getTime();
      return companyCreated >= START_TS;
    },
    // 可选：从 extraAttr 猜测商品编码传递给新素材空间
    productCodeResolved() {
      const e = this.extraAttr || {};
      return e.baseItemId || e.productId || e.id || e.erpSysItemId || ''
    }
  },
  watch: {
    editorFormItenClass: {
      immediate: true,
      handler(v) {
        if (!this.$el || !this.$el.parentNode) {
          return ;
        }
        this.fixFullScreenStyle()
      }
    }
  },
  methods: {
    onChange(v) {
        this.$emit('change', v)
    },
    // 修复富文本全屏的及非全屏层级问题
    fixFullScreenStyle() {
      let v = this.editorFormItenClass
      if (v[1].nofull) {
        this.$el.parentNode.style.zIndex = 1
      } else {
        this.$el.parentNode.style.zIndex = ""
      }
    },
    blurHandle() {
      this.elFormItem?.elForm?.validateField(this.key);
    },
    openPictureZone() {
      const that = this;
      this.choosePictrueZoneVisible = true
      this.$nextTick(() => {
        this.$refs.choosePictrueZoneRef.method_open({
          // limitSuffix: this.limitSuffix,
          isSingle: false,
          okFn(urlList) {
            let urls = urlList.map(item => item.url)
            that.$refs[that.key].addImages(urls);
          },
        })
      })
    },
    openNewPictureZone() {
      const that = this;
      this.chooseNewPictrueZoneVisible = true
      this.$nextTick(() => {
        this.$refs.chooseNewPictrueZoneRef.method_open({
          isSingle: false,
          productCode: this.productCodeResolved,
          outerId: this.injectedOuterId,
          folderId: localStorage.getItem('km_picture_folder_id') || '',
          okFn(fileList) {
            const urls = fileList.map(item => item.url)
            that.$refs[that.key].addImages(urls);
          },
        })
      })
    },
    // 统一入口：根据注册时间切换新旧素材空间
    handleOpenPictureZone() {
      // if (this.useNewPictureZone) {
        this.openNewPictureZone();
      // } else {
        // this.openPictureZone();
      // }
    },
  },
  mounted() {
    this.fixFullScreenStyle()
  }
}
</script>

<style lang="scss" scoped>

</style>